import React, { useEffect } from "react";
import { useParams } from "react-router";
import { NavLink, useNavigate } from "react-router-dom";
import { useGql } from "../Core/gqlHooks";
import { queryServicesPage } from "../Core/services";

import ServicesList from "../Components/servicesList/ServicesList";
import PageHeader from "../Components/pageHeader/PageHeader";
import { iCategorie } from "../Core/interface";
import { usePageSeo } from "../Core/utils";

import "./Services.scss";

const Services = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data, loading } = useGql({
    query: queryServicesPage,
  });

  const page = data?.pageService?.data?.attributes;
  const categories = data?.categories?.data;

  const currentCategory = categories?.find(
    (category: iCategorie) => category.attributes.slug === slug
  );

  useEffect(() => {
    if (!loading && categories?.length && !currentCategory) {
      navigate(`/services/${categories[0].attributes.slug}`, {
        replace: true,
      });
    }
  }, [currentCategory, categories, loading, navigate]);

  const categoryName = currentCategory?.attributes?.name
    ? `| ${currentCategory.attributes.name}`
    : "";

  usePageSeo({
    title: page?.pageTitle ? `${page.pageTitle} ${categoryName}` : undefined,
    keywords: page?.keywords,
    description: page?.metaDescription,
    category: currentCategory,
  });

  return (
    <div className="services-container page-container">
      <PageHeader title={page?.pageTitle} />
      {!loading && (
        <div className="main-container">
          <div className="page-content">
            <ul className="services-nav-list">
              {categories?.map((categorie: iCategorie) => (
                <li className="item" key={categorie.attributes.name}>
                  <NavLink
                    className="link"
                    to={`/services/${categorie.attributes.slug}`}
                    title={categorie.attributes.name}
                  >
                    <span className="title">{categorie.attributes.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
            <div className="list-services-container">
              <ServicesList category={currentCategory} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
